"use strict";

var _jsxRuntime = require("react/jsx-runtime");
module.exports = ({
  title,
  titleId,
  size,
  color,
  ...props
}) => /*#__PURE__*/(0, _jsxRuntime.jsxs)("svg", {
  ...props,
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24",
  height: size,
  width: size,
  fill: color,
  role: title ? 'img' : undefined,
  "aria-hidden": !title,
  "aria-labelledby": titleId,
  children: [title ? /*#__PURE__*/(0, _jsxRuntime.jsx)("title", {
    id: titleId,
    children: title
  }) : null, /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
    d: "M9.803 10.225H18.1l-1.107 1.015a.889.889 0 0 0-.102 1.175.72.72 0 0 0 1.077.094L20.825 9.9A.867.867 0 0 0 21 9.355a.867.867 0 0 0-.175-.547L17.968 6.2a.72.72 0 0 0-1.077.094.889.889 0 0 0 .103 1.175l1.265 1.16H9.803a.798.798 0 1 0 0 1.597Zm5.061 3.55H5.9l1.106-1.015a.889.889 0 0 0 .103-1.175.72.72 0 0 0-1.077-.094L3.175 14.1a.866.866 0 0 0-.175.545.867.867 0 0 0 .175.547L6.032 17.8a.72.72 0 0 0 1.077-.094.889.889 0 0 0-.102-1.175l-1.266-1.16h9.123a.798.798 0 1 0 0-1.597Z"
  })]
});